"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "stringToNumber", {
  enumerable: true,
  get: function get() {
    return _stringToNumber.stringToNumber;
  }
});
exports.formatNumbers = void 0;

var _stringToNumber = require("./string-to-number");

var convertToLocale = function convertToLocale(amount, locale) {
  var rawAmount = (0, _stringToNumber.stringToNumber)(amount);
  return locale ? rawAmount.toLocaleString(locale) : rawAmount;
};

var formatNumbers = function formatNumbers(amount, locale) {
  var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var suffix = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  if (!amount) return amount;
  return "".concat(prefix, " ").concat(convertToLocale(amount, locale), " ").concat(suffix).trim();
};

exports.formatNumbers = formatNumbers;